<input autocomplete="off" [disabled]="!contactSearchResult" (input)="onContactSearchInputChange($event.target.value)" [class]="'form-control  form-control-sm' + (showContactSearchResults ? '  mb-3' : '')" type="text" i18n-placeholder placeholder="Søg på leveringsadresse" data-lpignore="true"/>

<app-loader [minimal]="true" *ngIf="showContactSearchResults && !filteredSearchResults"></app-loader>
<app-loader [useOverlayLoader]="true" *ngIf="loading"></app-loader>

<div class="alert  alert-secondary  mb-0" *ngIf="(showContactSearchResults && filteredSearchResults && filteredSearchResults.length === 0) " i18n>
    <span class="text-muted">Ingen leveringsadresser matcher din søgning.</span>
</div>

<app-table [additionalClasses]="'  mb-0'" [autoSizeFirstColumn]="true"  *ngIf="(showContactSearchResults && filteredSearchResults && filteredSearchResults.length >= 1)">
    <thead>
        <tr>
            <th></th>
            <ng-container *ngFor="let contactField of filteredSearchResults[0].contact_type?.contact_field_preset?.contact_fields">
                <th class="centerized">
                    {{contactField.name}}
                </th>
            </ng-container>

            <th></th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let contact of filteredSearchResults">
            <td class="pt-1  pl-1">
                <button (click)="onClick(contact)" class="button  btn  btn-xs  btn-success m-0">
                    <fa-icon [icon]="pinIcon"></fa-icon>
                </button>
            </td>

            <ng-container *ngFor="let contactField of filteredSearchResults[0].contact_type?.contact_field_preset?.contact_fields">
                <td class="centerized">
                    {{contact.getContactField(contactField.id)}}
                </td>
            </ng-container>

            <td class="text-right  pr-1">
                <button (click)="delete(contact)" class="button  btn  btn-xs  btn-danger m-0">
                    <fa-icon [icon]="deleteIcon"></fa-icon>
                </button>
            </td>
        </tr>
    </tbody>
</app-table>
